/** @jsxImportSource @emotion/react */
"use client";

import type { Interpolation } from "@emotion/react";
import type { ToastProps as RadixToastProps } from "@radix-ui/react-toast";
import { Description } from "@radix-ui/react-toast";

import type { ThemeType } from "../../../../global/emotion";
import {
  fontSizes,
  fontWeights,
  lineHeights,
  spacing,
  stroke,
} from "../../../../global/emotion";
import type { HallowElementProps } from "../../../types/hallowElementProps.types";
import type { IconElement } from "../../_base/icons/Icon/Icon";
import { Popup } from "../Popup/Popup.emotion";

export type ToastProps = HallowElementProps<"div"> & {
  type?: RadixToastProps["type"];
  icon?: IconElement;
};

const messageStyle: Interpolation<ThemeType> = (theme) => ({
  color: theme.semanticColors.primary,
  fontSize: fontSizes.titleS,
  fontWeight: fontWeights.titleS,
  lineHeight: lineHeights.titleS,
});
const toastStyle: Interpolation<ThemeType> = (theme) => ({
  borderColor: theme.semanticColors.neutralsLowest,
  borderStyle: "solid",
  borderWidth: stroke.light,
  maxWidth: "max-content",
  padding: `${spacing.xxs} ${spacing.ms}`,
});

export const Toast = ({ children, icon, type = "foreground" }: ToastProps) => {
  return (
    <Popup durationMs={2500} type={type} css={toastStyle} icon={icon}>
      <Description css={messageStyle}>{children}</Description>
    </Popup>
  );
};
